import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendService } from '../../core/backend.service';
import { Unit, UoMCategory } from '../../viewmodels/unit';

@Injectable()
export class UomService {
  private uoms: Unit[] = [];

  constructor(private backendService: BackendService) {
  }

  getUomId(uomName: string): string {
    const uom = this.uoms.find(u => u.uomName === uomName);
    return uom ? uom.uomId : '';
  }

  getUomName(uomId: string): string {
    const uom = this.uoms.find(u => u.uomId === uomId);
    return uom ? uom.uomName : '';
  }

  getUoms(): Unit[] {
    return _.sortBy(this.uoms, (item: Unit) => item.uomName);
  }

  getCategorizedUoms(category: UoMCategory): Unit[] {
    return _.filter(this.uoms, (item: Unit) => item.category === category);
  }

  load(): Observable<boolean> {
    return this.backendService.getAll<Unit>(Unit).pipe(map(uoms => {
      if (uoms) {
        this.uoms = uoms;
      }

      return uoms ? true : false;
    }));
  }
}
